import React, { PureComponent } from "react";

export default class ProjectContentTypeFormMetadata extends PureComponent {
  static displayName = "Project.Content.TypeForm.Types.Metadata";

  render() {
    return null;
  }
}
